<list-chips *ngIf="chipsView"></list-chips>
<div class="new-filters-modal" [hidden]="chipsView">
  <div class="title__wrapper">
    <span class="title">{{ 'List.Filters.filters' | translate }}</span>
    <svg-icon class="clear-icon" [src]="'/assets/img/close-icon.svg'" (click)="cancel()"></svg-icon>
  </div>
  <div class="rows__wrapper">
    <div class="new-filters-modal__row">
      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectChanges.List.creator' | translate"
        [iconUrl]="'/assets/img/ic-person-circle-outline.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[a-creator][in]'"
        (change)="onChangeFilter()"
        [multiple]="true"
        [searchGetParams]="'search'"
        [requiredIdUrl]="Config.API + '/employee/search'"
        [valueTransform]="creatorName.bind(this)"
        (selectedValues)="handleSelectedValues($event, '[a-creator][in]')"
      />

      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectChanges.List.status' | translate"
        [iconUrl]="'/assets/img/ic-checkmark-circle-outline.svg'"
        [form]="service?.filtersForm"
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [controlName]="'[a-changeStatus][eq]'"
        (change)="onChangeFilter()"
        [localItems]="statuses"
        (selectedValues)="handleSelectedValues($event, '[a-changeStatus][eq]')"
      />
    </div>

    <div class="new-filters-modal__row">
      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectChanges.List.category' | translate"
        [iconUrl]="'/assets/img/ic-check-square.svg'"
        [form]="service?.filtersForm"
        bindValue="id"
        bindLabel="name"
        [controlName]="'[a-changeType][in]'"
        (change)="onChangeFilter()"
        [multiple]="true"
        [localItems]="changeTypes"
        (selectedValues)="handleSelectedValues($event, '[a-changeType][in]')"
      />

      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectChanges.List.type' | translate"
        [iconUrl]="'/assets/img/ic-check-square.svg'"
        [form]="service?.filtersForm"
        bindValue="id"
        bindLabel="name"
        [control]="typeControl"
        [multiple]="true"
        (change)="onTypeChange()"
        [localItems]="types"
      />
    </div>

    <div class="new-filters-modal__row">
      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectChanges.List.settlementStatus' | translate"
        [iconUrl]="'/assets/img/ic-checkmark-circle-outline.svg'"
        [form]="service?.filtersForm"
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [controlName]="'[a-settlementStatus][eq]'"
        (change)="onChangeFilter()"
        [localItems]="settlements"
        (selectedValues)="handleSelectedValues($event, '[a-settlementStatus][eq]')"
      />

      <div class="w-100">
        <div class="new-select-label">{{ 'ProjectChanges.List.dateRange' | translate }}</div>
        <daterangepicker-v2
          #daterangepicker
          [form]="service?.filtersForm"
          [controlStart]="'[a-termStart][gte]'"
          [controlEnd]="'[a-termEnd][lte]'"
          [title]="'ProjectChanges.List.dateRange' | translate"
          (rangeChanged)="onChangeFilter()"
        />
      </div>
    </div>
  </div>
  <div class="buttons">
    <list-single-clear-filters-v2
      [form]="service?.filtersForm"
      (change)="onChangeFilter()"
      [shouldShowClearFilters]="shouldShowClearFilters.bind(this)"
      [clearFilters]="clearFilters.bind(this)"
    />
    <div class="buttons__inside">
      <app-button
        [type]="'button'"
        (onClick)="cancel()"
        [config]="{
          size: ButtonSize.LARGE,
          smSize: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
          text: 'DATERANGEPICKER.cancelBtn' | translate
        }"
      />

      <app-button
        [type]="'button'"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="submit()"
        [config]="{
          size: ButtonSize.LARGE,
          smSize: ButtonSize.SMALL,
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: 'DATERANGEPICKER.acceptBtn' | translate,
          prependSrc: './assets/img/tick-icon.svg'
        }"
      />
    </div>
  </div>
</div>
